/**
 * The entity modify flags.
 */
export enum EntityModifyFlags {
  /** The parent changes. */
  Parent = 0x1,
  /** The child changes. */
  Child = 0x2
}
